import { Card, Button, styled, Box } from '../../../base';

export const CardWrapper = styled(Card)(({ theme }) => ({
    padding: theme.spacing(1.5),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
    marginInlineEnd: theme.spacing(2),
    paddingInline: theme.spacing(4),
    borderRadius: theme.spacing(0.5),
}));

export const StyledContentContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    overflowY: 'auto',
    scrollbarGutter: 'stable',
    flex: 1,
    maxHeight: 500,
}));
